/**
 * Centralized query param definitions grouped by route/context.
 * Helps avoid collisions, duplicated strings, and inconsistent naming.
 */
export const QUERY_PARAMS = {
  /**
   * Job board state persisted in the URL.
   */
  jobBoard: {
    searchText: "SEARCH",
    location: "LOCATION",
    jobType: "JOB_TYPE",
    page: "PAGE",
  },
  /**
   * Shared route state.
   */
  locale: "LOCALE",
} as const;
